import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapProductDto = (
    product: ProductDto,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const { brand, erpNumber, id, isDiscontinued, pricing, qtyOrdered, unitOfMeasure, shortDescription } = product;

    return {
        discontinued: isDiscontinued || undefined,
        item_brand: brand?.name || undefined,
        item_id: erpNumber,
        item_name: shortDescription,
        price: ga.util.parseAmount(pricing?.unitNetPrice) || undefined,
        quantity: qtyOrdered ?? 1,
        unit_of_measure: unitOfMeasure || undefined,
        ...ga.map.productInfosOption(options, id),
        ...options?.itemData,
    };
};

export default mapProductDto;
